import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Text = styled.div`
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const CountdownTimer = ({ targetTime }: { targetTime: string }) => {
  const [remainingTime, setRemainingTime] = useState<string>('계산 중...');

  useEffect(() => {
    const updateRemainingTime = () => {
      setRemainingTime(calculateRemainingTime(targetTime));
    };

    // 매 초마다 업데이트
    const interval = setInterval(updateRemainingTime, 1000);

    // 초기값 설정
    updateRemainingTime();

    // 컴포넌트 언마운트 시 인터벌 정리
    return () => clearInterval(interval);
  }, [targetTime]);

  return <Text>{remainingTime}</Text>;
};

const calculateRemainingTime = (targetTime: string): string => {
  const now = new Date();
  const targetDate = new Date(targetTime);

  // targetTime 유효성 검사
  if (isNaN(targetDate.getTime())) {
    return '';
  }

  const difference = targetDate.getTime() - now.getTime();

  if (difference <= 0) {
    return '시간이 만료되었습니다.';
  }

  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);

  return `${minutes}분 ${seconds}초 남음`;
};

export default CountdownTimer;
